/* eslint-disable no-undef */
let promise;

export default function loadBMap(ak) {
  if (!promise) {
    promise = new Promise(function (resolve, reject) {
      if (typeof BMap !== 'undefined') {
        resolve(BMap);
        return true;
      }
      window.onBMapCallback = function () {
        resolve(BMap);
      };
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = window.location.protocol + '//api.map.baidu.com/api?v=3.0&ak=' + ak + '&callback=onBMapCallback';
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  return promise;
}
